import React from "react"

import { Wrapper } from "./styles"

const Code = ({ element }) => <Wrapper html={element.code} />

export default Code
